<script>
    import {showDialogLogin} from "../../js/stores";
    import {fade} from "svelte/transition"
    import Register from "./DialogLogin/Register.svelte";
    import Login from "./DialogLogin/Login.svelte";
    import ForgottenPassword from "./DialogLogin/ForgottenPassword.svelte";
    import Check from "./DialogLogin/Check.svelte";
    import Error from "./DialogLogin/Error.svelte";
    import NotVerified from "./DialogLogin/NotVerified.svelte";
    import ChangeForgottenPassword from "./DialogLogin/ChangeForgottenPassword.svelte";
    import AccountActivation from "./DialogLogin/AccountActivation.svelte";

    let typeSwitch = $showDialogLogin.type === "register";
</script>

<dialog transition:fade={{duration: 100}}>
    <div class="dialog-background" on:click={() => showDialogLogin.set({show: false, type: "", data: {}})}></div>
    <div class="dialog-content">
        <div class="row">
            <div class="d-none d-lg-block col-lg-5">
                <div class="dc-info">
                    <div class="info-image">
                        <img src="assets/img/pneuin-cb-logo.svg" alt="Logo PNEUIN.sk">
                    </div>
                    <div class="info-text">
                        <span>Zaregistrujte sa a získajte:</span>
                        <ul>
                            <li><i class="fal fa-fw fa-clock-rotate-left"></i>Prehľad o histórii objednávok</li>
                            <li><i class="fas fa-fw fa-truck-fast"></i>Sledovanie objednávok</li>
                            <li><i class="fas fa-fw fa-map-location-dot"></i>Rýchle dopĺňanie adries</li>
                        </ul>
                    </div>
                </div>
            </div>
            <div class="col-12 col-lg-7">
                <button type="button" class="dc-close" on:click={() => showDialogLogin.set({show: false, type: "", data: {}})}>
                    <i class="far fa-fw fa-xmark"></i>
                </button>
                <div class="dc-content">
                    {#if $showDialogLogin.type === "login" || $showDialogLogin.type === "register"}
                        <div class="dc-switch">
                            <div class="button">
                                <input type="checkbox" class="checkbox" bind:checked={typeSwitch}>
                                <div class="knobs">
                                    <span>Prihlásenie</span>
                                </div>
                                <div class="layer"></div>
                            </div>
                        </div>
                        <div class="dc-form">
                            {#if typeSwitch === true}
                                <Register/>
                            {:else}
                                <Login/>
                            {/if}
                        </div>
                    {:else if $showDialogLogin.type === "forgottenPassword"}
                        <div class="dc-form">
                            <ForgottenPassword/>
                        </div>
                    {:else if $showDialogLogin.type === "emailNotVerified"}
                        <div class="dc-form">
                            <NotVerified/>
                        </div>
                    {:else if $showDialogLogin.type === "check"}
                        <div class="dc-form">
                            <Check/>
                        </div>
                    {:else if $showDialogLogin.type === "changeForgottenPassword"}
                        <div class="dc-form">
                            <ChangeForgottenPassword/>
                        </div>
                    {:else if $showDialogLogin.type === "accountActivation"}
                        <div class="dc-form">
                            <AccountActivation/>
                        </div>
                    {:else if $showDialogLogin.type === "error"}
                        <div class="dc-form">
                            <Error/>
                        </div>
                    {/if}
                </div>
            </div>
        </div>
    </div>
</dialog>

<style>
    dialog {
        position: absolute;
        z-index: 1000;
        height: 100%;
        width: 100%;
        top: 0;
        left: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #00000080;
        backdrop-filter: blur(5px);
        -webkit-backdrop-filter: blur(5px);
        border: 0;
    }
    dialog .dialog-background {
        position: absolute;
        width: 100%;
        height: 100%;
        z-index: 500;
    }
    dialog .dialog-content {
        height: 40rem;
        min-height: 70vh;
        max-height: 100%;
        width: 65vw;
        border-radius: 2rem;
        overflow: hidden;
        background-color: white;
        z-index: 800;
    }
    dialog .dialog-content .dc-info {
        height: 40rem;
        min-height: 70vh;
        max-height: 100%;
        position: relative;
        background-color: black;
        background-image: url("../../assets/img/tires.png");
        background-position: bottom;
        background-size: contain;
        background-repeat: no-repeat;

        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
    }
    dialog .dialog-content .dc-info .info-image {
        width: 17rem;
        position: absolute;
        top: 5rem;
    }
    dialog .dialog-content .dc-info .info-image img {
        width: 100%;
        filter: grayscale(1) invert(1);
    }
    dialog .dialog-content .dc-info .info-text span {
        color: white;
        font-family: Rubik, sans-serif;
        font-weight: 500;
        font-size: 1.3rem;
    }
    dialog .dialog-content .dc-info .info-text ul {
        margin-top: 2rem;
        padding-left: 0;
        list-style-type: none;
        display: flex;
        flex-direction: column;
        gap: .75rem;
    }
    dialog .dialog-content .dc-info .info-text ul li {
        padding: .75rem 1rem;
        color: white;
        background-color: rgba(255, 255, 255, .1);
        border: 1px solid rgba(255, 255, 255, .1);
    }
    dialog .dialog-content .dc-info .info-text ul li i {
        margin-right: .75rem;
        font-size: 1.15rem;
        color: rgba(255, 255, 255, .3);
    }
    dialog .dialog-content .dc-close {
        font-size: 1.25rem;
        position: absolute;
        top: 1rem;
        right: 2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        width: 3rem;
        height: 3rem;
        cursor: pointer;
        transition: .1s linear;
        color: var(--color-slate-600);
        background-color: var(--color-slate-50);
        border: 1px solid var(--color-slate-200);
    }
    dialog .dialog-content .dc-close:hover {
        color: var(--color-slate-900);
        border-color: var(--color-slate-400);
    }
    dialog .dialog-content .dc-content {
        display: flex;
        flex-direction: column;
        justify-content: center;
        place-items: center;
        margin: 0 4rem 0 2rem;
        height: 100%;
        padding: 1.5rem 0;
    }
    dialog .dialog-content .dc-switch {
        position: absolute;
        top: 3rem;
    }
    dialog .dialog-content .dc-switch .button {
        position: relative;
        width: 18rem;
        height: 4rem;
        border-radius: .5rem;
        overflow: hidden;
        font-family: Rubik, sans-serif;
        font-weight: 400;
    }
    dialog .dialog-content .dc-switch .checkbox {
        position: relative;
        width: 100%;
        height: 100%;
        padding: 0;
        margin: 0;
        opacity: 0;
        cursor: pointer;
        z-index: 3;
    }
    dialog .dialog-content .dc-switch .button .knobs,
    dialog .dialog-content .dc-switch .button .layer {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
    }
    dialog .dialog-content .dc-switch .button .knobs {
        z-index: 2;
    }
    dialog .dialog-content .dc-switch .button .layer {
        width: 100%;
        transition: .2s ease all;
        z-index: 1;
        background-color: var(--color-slate-100);
    }
    dialog .button .knobs:before, .button .knobs:after, .button .knobs span {
        position: absolute;
        width: 50%;
        height: 100%;
        font-size: 10px;
        text-align: center;
        line-height: 1;
        padding: 9px 4px;
        border-radius: .25rem;
        transition: .2s ease all;
        left: 0;
    }
    dialog .button .knobs:before {
        content: '';
        height: 84%;
        width: 48%;
        top: .3rem;
        left: .3rem;
        background-color: white;
    }
    dialog .button .knobs:after {
        content: 'Registrácia';
        left: 50%;
        color: var(--color-slate-600);
        font-size: 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    dialog .button .knobs span {
        font-size: 1.2rem;
        display: flex;
        justify-content: center;
        align-items: center;
        left: 0;
        color: var(--color-slate-900);
        z-index: 1;
    }
    dialog .button .checkbox:checked + .knobs span {
        color: var(--color-slate-600);
    }
    dialog .button .checkbox:checked + .knobs:before {
        left: 50.5%;
    }
    dialog .button .checkbox:checked + .knobs:after {
        color: var(--color-slate-900);
    }
    dialog .dialog-content .dc-form {
        text-align: center;
        padding-top: 3rem;
        width: 22rem;
    }
    @media (max-width: 1399px) {
        dialog .dialog-content {
            width: 70vw;
        }
    }
    @media (max-width: 1200px) {
        dialog .dialog-content {
            width: 80vw;
        }
    }
    @media (max-width: 991px) {
        dialog .dialog-content .dc-content {
            height: 90vh;
            margin: 0 2rem;
        }
    }
    @media (max-width: 767px) {
        dialog .dialog-content {
            width: 100%;
            height: 100%;
        }
        dialog .dialog-content .dc-content {
            padding: 4rem 0;
        }
        dialog .dialog-content .dc-switch {
            top: 3rem;
        }
        dialog .dialog-content .dc-switch .button {
            width: 19rem;
        }
        dialog .dialog-content .dc-form {
            max-width: 100%;
        }
    }
</style>